import { render } from "./aig.vue?vue&type=template&id=4167de78"
import script from "./aig.vue?vue&type=script&lang=js"
export * from "./aig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__